/**
 * Created by bscholl on 15.02.17.
 */
import AbstractTransition from './AbstractTransition';
import LogUtil from '@/core/utils/logUtil';
import {gsap} from 'gsap';

export default class NextStepTransition extends AbstractTransition {

    constructor(currentView, nextView) {
        super(currentView, nextView);
    }

    getViewId(view) {

        if(view) {
            return view.id;
        }
        else {
            return null;
        }
    }

    getNextOffset(view) {
        let offset = view._data.animations[this.getViewId(view)].offset;
        return offset ? offset : '+=0';
    }

    _createTransition() {
        LogUtil.logClass(this, 'create default Transition', this.getViewId(this._currentView), this.getViewId(this._nextView));

       //this._timeline.add(gsap.set(this._nextView, {autoAlpha:0}));

        if(this._currentView) {
            this._timeline.add(this._currentView.getHideAnimation());

            // Add animations relating to whole views here (component specific animations should be in hide/showAnimation).

            // CURRENTLY HOWEVER, we micromanage overlapping animations on component-level in each step.

            //this._timeline.addLabel('startTransition', '+=0');
            //this._timeline.add(gsap.set(this._nextView.element, {opacity: 0}), 'startTransition');
            //this._timeline.add(gsap.to(this._currentView.element, 0.8, {opacity: 0}),'startTransition');
            //this._timeline.add(gsap.to(this._nextView.element, 0.8, {opacity: 1}),'startTransition');
        }

        this._timeline.set(this._nextView, {visible: true}, this.getNextOffset(this._nextView));
        this._timeline.add(this._nextView.getShowAnimation(), this.getNextOffset(this._nextView));
    }

}
